export default __webpack_public_path__ + "static/media/google-play-badge1.acd0c270.png";